module.exports = __webpack_public_path__ + "73540867bdfe8afb90f946ce6bc2e928.jpg";